import React, { PropTypes } from 'react';
import Input from '../../form/Input';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import {reduxForm} from 'redux-form';
import s from '../style';

class RestorePassword extends React.Component {
  static propTypes = {
    message: PropTypes.string,
    fields: PropTypes.shape({
      email: PropTypes.object.isRequired
    }),
    handleSubmit: PropTypes.func.isRequired,
    forgotPassword: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
  };

  onSubmit({email}) {
    return this.props.forgotPassword(email);
  }

  render() {
    const { fields: {email}, handleSubmit, submitting} = this.props;
    return (
      <Paper zDepth={1} className={s.formCard}>
        <form onSubmit={handleSubmit(data => this.onSubmit(data))}>
          <h2>Restore password</h2>
          <div>
            <Input type="email" label="Email" required {...email}/>
          </div>
          <div className={s.linkContent}>
            <RaisedButton label="Restore" raised secondary disabled={submitting} type="submit"/>
          </div>
        </form>
      </Paper>
    );
  }
}

export default reduxForm({
  form: 'restore-password',
  fields: ['email']
})(RestorePassword);



// WEBPACK FOOTER //
// ./src/components/auth/RestorePassword/RestorePassword.jsx